(() => {
  const allowedAudiences = new Set(['pet', 'partner', 'person']);
  const allowedDirections = new Set(['f2m', 'm2f', 'neutral', 'unknown']);
  const url = new URL(window.location.href);
  const query = url.searchParams;

  const clean = (value, max = 120) => String(value || '').trim().slice(0, max);
  const safeGet = (key) => {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  };
  const safeSet = (key, value) => {
    try { window.sessionStorage.setItem(key, value); } catch (_) {}
  };

  const landing = document.querySelector('[data-mf-landing]');
  const defaultAudience = clean(landing?.dataset.mfLanding);
  const defaultDirection = clean(landing?.dataset.mfDirection || 'neutral');
  const queryAudience = clean(query.get('mf_audience'));
  const queryDirection = clean(query.get('mf_direction'));
  const audience = allowedAudiences.has(queryAudience)
    ? queryAudience
    : (allowedAudiences.has(defaultAudience) ? defaultAudience : clean(safeGet('mf_audience')));
  const direction = allowedDirections.has(queryDirection)
    ? queryDirection
    : (allowedDirections.has(defaultDirection) ? defaultDirection : clean(safeGet('mf_direction') || 'unknown'));

  if (allowedAudiences.has(audience)) safeSet('mf_audience', audience);
  if (allowedDirections.has(direction)) safeSet('mf_direction', direction);

  const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const attribution = {};
  attributionKeys.forEach((key) => {
    const incoming = clean(query.get(key));
    if (incoming) safeSet(`mf_${key}`, incoming);
    attribution[key] = incoming || clean(safeGet(`mf_${key}`));
  });

  const publish = (name, detail = {}) => {
    const payload = {
      ...detail,
      audience: allowedAudiences.has(audience) ? audience : 'unknown',
      direction: allowedDirections.has(direction) ? direction : 'unknown',
      direction_source: queryDirection ? 'campaign_parameter' : 'landing_or_session',
      page_path: window.location.pathname,
      ...attribution,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
    window.dispatchEvent(new CustomEvent(`momentfig:${name}`, { detail: payload }));
    if (window.Shopify?.analytics?.publish) {
      try { window.Shopify.analytics.publish(name, payload); } catch (_) {}
    }
  };

  if (landing) publish('mf_landing_view', { landing_handle: window.location.pathname.split('/').pop() });

  document.querySelectorAll('[data-mf-product-link]').forEach((link) => {
    const target = new URL(link.href, window.location.origin);
    if (allowedAudiences.has(audience)) target.searchParams.set('mf_audience', audience);
    if (allowedDirections.has(direction)) target.searchParams.set('mf_direction', direction);
    attributionKeys.forEach((key) => {
      if (attribution[key] && !target.searchParams.has(key)) target.searchParams.set(key, attribution[key]);
    });
    link.href = target.toString();
  });

  const addHidden = (form, name, value) => {
    if (!value || form.querySelector(`input[name="${name}"]`)) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    addHidden(form, 'properties[_MF audience]', allowedAudiences.has(audience) ? audience : 'unknown');
    addHidden(form, 'properties[_MF direction]', allowedDirections.has(direction) ? direction : 'unknown');
    addHidden(form, 'properties[_MF direction source]', queryDirection ? 'campaign' : 'session');
    attributionKeys.forEach((key) => addHidden(form, `properties[_MF ${key}]`, attribution[key]));
  });

  let uploadStarted = false;
  let uploadCompleted = false;
  const isUpload = (target) => target instanceof HTMLInputElement && target.type === 'file';
  const startUpload = (target) => {
    if (!isUpload(target) || uploadStarted) return;
    uploadStarted = true;
    publish('photo_upload_started', { input_name: clean(target.name, 80) });
  };

  document.addEventListener('pointerdown', (event) => startUpload(event.target), true);
  document.addEventListener('focusin', (event) => startUpload(event.target), true);
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('.uploadcare--widget__button_type_open, .uploadcare--tab__action-button, .uploadcare--file-source, .uploadcare--camera__button_type_capture')
      : null;
    if (!trigger || uploadStarted) return;
    uploadStarted = true;
    publish('photo_upload_started', { upload_provider: 'uploadcare' });
  }, true);
  document.addEventListener('change', (event) => {
    if (!isUpload(event.target) || !event.target.files?.length) return;
    // This route confirms Uploadly's hosted file separately from local selection.
    if (document.querySelector('[data-mf-boyfriend], [data-mf-general]')) {
      publish('photo_selected', { file_count: event.target.files.length });
      return;
    }
    uploadCompleted = true;
    publish('photo_upload_completed', {
      input_name: clean(event.target.name, 80),
      file_count: event.target.files.length,
    });
  }, true);

  const uploadObserver = new MutationObserver(() => {
    if (uploadCompleted) return;
    const boyfriendForm = document.querySelector('[data-mf-boyfriend] form, [data-mf-general] form');
    if (boyfriendForm) {
      const hostedFile = Array.from(boyfriendForm.querySelectorAll('input[name^="properties["]')).some((input) =>
        !input.name.includes('_MF') && /^https:\/\//.test(input.value)
      );
      if (!hostedFile) return;
      uploadCompleted = true;
      publish('photo_upload_completed', { upload_provider: 'uploadly', file_count: 1 });
      return;
    }
    const completedWidget = document.querySelector(
      '.uploadcare--widget_status_loaded, .uploadcare--widget_status_success, .uploadcare--widget_status_ready.uploadcare--widget_has_value'
    );
    const widgetText = clean(document.querySelector('.uploadcare--widget__text')?.textContent, 180);
    if (!completedWidget && !widgetText) return;
    uploadCompleted = true;
    publish('photo_upload_completed', { upload_provider: 'uploadcare' });
  });
  uploadObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

})();
